import { useParentWindow } from '@membranehq/ui/hooks/useParentWindow'
import { useEffect } from 'react'

import { OpenInNewTabButton } from '../EmbedPopup/elements/OpenInNewTabButton'
import { Popup as ConsolePopup } from '../Popup'
import { EmbedIsolateLayout } from './EmbedIsolateLayout'

export function EmbedIsolateWindow({ children }: { children: React.ReactNode }) {
  const { handshake } = useParentWindow()

  useEffect(() => {
    // Send handshake to the parent window so that it knows we are alive.
    void handshake()
  }, [])

  return (
    <ConsolePopup.Root>
      <EmbedIsolateLayout.Window>
        <OpenInNewTabButton />
        {children}
      </EmbedIsolateLayout.Window>
    </ConsolePopup.Root>
  )
}
